/**
 * Facade for all validators used in the application.
 */
import { PhoneNumberUtil } from 'google-libphonenumber'
import { default as validatorjs } from 'validator'

// libphonenumber is used for phone number validation since it is more accurate than validatorjs's version
const phoneNumberUtil = PhoneNumberUtil.getInstance()
function isMobilePhone(phoneNumber?: string, options = { regionCode: 'DE', required: false }) {
    if (!phoneNumber) {
        return !options.required
    }
    try {
        const result = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, options.regionCode)
        return phoneNumberUtil.isValidNumber(result)
    } catch {
        return false
    }
}

function isEmail(email?: string, options: { required?: boolean } = {}) {
    if (!email) {
        return !options.required
    }
    return validatorjs.isEmail(email)
}

export const validators = {
    ...validatorjs,
    // Validatorjs overwrites:
    isMobilePhone,
    isEmail,
}
